import { nanoid } from 'nanoid';

export function createOperationInvocationId(): string {
  return `tb-op-${nanoid()}`;
}
